<template>
    <div>
        <div class="content">
            <div class="title-box">
                <h3>{{multiLanguage.ibreport.text}}</h3>
            </div>
            <div class="panel" v-loading="loading" element-loading-spinner="el-icon-loading">
                <mtable v-if="trData"
                :thData="thData"
                :trData="trData"
                :multiLanguage="multiLanguage"
                :selPage="selPage"
                :page="page"
                :jsonExcelAjax="jsonExcelAjax"
                :downLoadTran="downLoadTran"
                :sort="sort"
                :name="name"
                @tableChange="tableAjax">
                    <div slot="handle" class="ibReportSlot">
                        <div class="ibReportSelect">
                            <span>{{multiLanguage.ibreport.statusText}}</span>
                            <el-select v-model="type" style="width:100px" @change="searchData">
                                <el-option
                                v-for="(key, val) in multiLanguage.ibreport.statusList"
                                :key="val"
                                :label="key"
                                :value="val">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="ibReportInput">
                            <span>{{multiLanguage.ibreport.ibAccountText}}</span>
                            <el-input v-model="ibAccount" style="width: 180px"></el-input>
                            <el-button type="primary" @click="searchData">
                                {{multiLanguage.search}}
                            </el-button>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </div>                                           
                    </div>
                </mtable>
            </div>
        </div>
    </div>
</template>
<script>
import mtable from "../../comm/mytable"
import {getTimeDiff, updateTimeByUtc} from 'common/js/util'
import {URL_ACTIVEREPORT} from 'api/commissionApi'
import { Api } from 'api/commissionEnv'
let api = new Api()

export default {
    name: "ibreport",
    mixins: [
      require("common/mixin/base.js").base({multiLanguage:"commissionTable"})
    ],
    props: ['curArea'],
    data () {
      return {
        ibAccount:'',
        type: '-1',
        timeDiff: 0,
        changeTime: false,
        url: '',
        trData: [], //  表格tr数据 
        sort: {  // 排序
          key: "",
          method: "ASC"
        },
        page: {  // 分页
          active: 1,
          pageLeng: 0
        },
        selPage: {  //  配合分页的显示col数目选择
          list: [5, 10, 25, 50],
          active: localStorage.pageMaxIndex,
          limit: [5, 10, 25, 50][localStorage.pageMaxIndex]
        },
        loading: true
      }
    },
    mounted () {
        this.timeDiff = getTimeDiff()
        this.tableAjax()
    },
    computed: {
        thData() {  // 表格th数据
            return this.multiLanguage.ibTh
        },
        name(){
            return this.multiLanguage.ibreport.text
        },
        downLoadTran(){
            return { STATUS: this.multiLanguage.ibreport.statusList}
        },
        jsonExcelAjax () {
            return {
                url: this.url,
                ajaxType: "get",
                getKey: ["data", "data", "rows"],
                ajaxPar: {
                    pageSize: this.page.pageLeng,
                    pageNum: 0,
                    area: this.LANGUAGE,
                    sort: this.sort.method,
                    sortKey: this.sort.key,
                    id: this.ibAccount,
                    type: this.type
                }
            }
        }
    },
    methods: {
        searchData(){
            this.loading = true
            this.page.active = 1
            this.tableAjax()
        },
        tableAjax(){
            this.changeTime = true
            this.url = api.getUrl20(this.curArea,URL_ACTIVEREPORT)
            let obj = {
                params: {
                    id: this.ibAccount,
                    type: this.type,
                    sort: this.sort.method,
                    sortKey: this.sort.key,
                    pageNum: this.page.active - 1,
                    pageSize: this.selPage.limit
                },
                headers: {
                    UTCDIFF: this.timeDiff
                }
            }
            this.getIbReportDatas(this.url,obj)
        },
        getIbReportDatas(url,obj){
            this.$http.get(url, obj).then((res) => {
                this.trData = res.data.data.rows
                this.page.pageLeng = res.data.data.count
                this.setOfficeState()
                this.loading = false
            })
        },
        setOfficeState() {
            let list = this.multiLanguage.ibreport.statusList
            if (Object.prototype.toString.call(this.trData) == "[object Array]") {
                this.trData.forEach((item,index) =>{
                    let temp = this.trData[index]
                    temp.status = (temp.STATUS || temp.STATUS == 0) ? list[temp.STATUS] : ''
                    if(this.changeTime) {
                        temp.FIRST_REBATE_TIME = updateTimeByUtc(this.timeDiff, temp.FIRST_REBATE_TIME)
                        temp.LAST_REBATE_TIME = updateTimeByUtc(this.timeDiff, temp.LAST_REBATE_TIME)
                    }
                })
            }
        }
    },
    watch:{
        multiLanguage() {     
            this.changeTime = false
            this.setOfficeState()
        },
        curArea () {
            this.ibAccount = ''
            this.type = '-1'
            this.sort.method = 'ASC'
            this.sort.key = ''
            this.loading = true
            this.tableAjax()
        }
    },
    components: {
      mtable
    }
  }
</script>
<style lang="scss" type="text/scss" scoped>
    .title-box{
        border: 1px solid #3F51B5;
        background: #3F51B5;
        padding: 0 20px;
        color: #fff;
        border-radius: 5px 5px 0 0;
    }
    .ibReportSlot{
        float: left;
        .ibReportSelect{
            float: left;
        }
        .ibReportInput{
            float: left;
            margin-left: 200px;
        }
    }
</style>



// WEBPACK FOOTER //
// ibReport.vue?725bdabc